import { Button, Heading, Icon } from "@trueskin-web/components"
import { simpleEditIcon } from "@trueskin-web/theme/icons/simpleEditIcon"

import checkCircleFilledIcon from "./images/checkCircleFilledIcon.svg"
import dashedCircleIcon from "./images/dashedCircleIcon.svg"
import rightArrowCircleFilledIcon from "./images/rightArrowCircleFilledIcon.svg"

const getIcon = (status) =>
  status === "completed"
    ? checkCircleFilledIcon
    : status === "current"
    ? rightArrowCircleFilledIcon
    : dashedCircleIcon

const Card = ({
  title,
  status,
  showLine = true,
  onClick,
  children,
  className,
}) => {
  const isCompleted = status === "completed"

  return (
    <div
      sx={{
        position: "relative",
        py: 4,
        pr: 4,
        pl: 52,
        mb: 2,
        border: "1px",
        borderRadius: "8px",
        borderColor: "brandNeutralsMediumGrey",
      }}
      className={className}
    >
      {showLine && (
        <div
          sx={{
            position: "absolute",
            top: 36,
            left: isCompleted ? 27 : 28,
            width: isCompleted ? "2px" : "1px",
            height: "100%",
            backgroundColor: isCompleted ? "primary" : "white",
            backgroundImage:
              !isCompleted &&
              "linear-gradient(hsla(0, 0%, 90%, 1) 50%, rgba(255, 255, 255, 0) 0%)",
            backgroundSize: "2px 16px",
            zIndex: 1,
          }}
        />
      )}

      <img
        src={getIcon(status)}
        alt=""
        width={24}
        height={24}
        sx={{
          position: "absolute",
          top: "20px",
          left: 4,
          zIndex: 2,
          backgroundColor: "white",
        }}
      />

      <div
        sx={{
          display: "flex",
          columnGap: 2,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {title && (
          <Heading
            size="sm"
            sx={{
              fontWeight: "bold",
              lineHeight: "smallerHeading",
            }}
          >
            {title}
          </Heading>
        )}
        {onClick && (
          <Button variant="link" size="sm" onClick={onClick} sx={{ p: 0 }}>
            <Icon icon={simpleEditIcon} color="textLight" />
          </Button>
        )}
      </div>
      <div
        sx={{
          fontSize: 1,
          color: "textLight",
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default Card
